import { render } from "./propertyDeclaration.vue?vue&type=template&id=5f1d4b34&scoped=true"
import script from "./propertyDeclaration.vue?vue&type=script&lang=js"
export * from "./propertyDeclaration.vue?vue&type=script&lang=js"

import "./propertyDeclaration.vue?vue&type=style&index=0&id=5f1d4b34&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1d4b34"]])

export default __exports__